import { render, staticRenderFns } from "./ReceptionPatientHistory.vue?vue&type=template&id=8ca15424&scoped=true"
import script from "./ReceptionPatientHistory.vue?vue&type=script&lang=js"
export * from "./ReceptionPatientHistory.vue?vue&type=script&lang=js"
import style0 from "./ReceptionPatientHistory.vue?vue&type=style&index=0&id=8ca15424&prod&lang=scss&scoped=true"
import style1 from "./ReceptionPatientHistory.vue?vue&type=style&index=1&id=8ca15424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca15424",
  null
  
)

export default component.exports